import { useMemo, useState } from 'react';
import { PRICECODE_WEIGHTCONTROLLED } from '~/common/constants/ppConstants';
import { formatPrice } from '~/common/utils/numberUtil';
import { useTranslation } from 'react-i18next';
import { getSplittedArticlePrice } from '~/features/catalog/utils/articleUtil';
import type { AghArticleDetail } from '~/common/types/aghArticleDetail';
import { isFuture } from 'date-fns';

export function useCatalogAghArticleDetail(baseArticle: AghArticleDetail, initialQuantity?: number) {
  const { i18n } = useTranslation();

  const allArticles = baseArticle.isZzArticle ? [baseArticle, ...baseArticle.zzArticles] : [baseArticle];

  const [selectedArticleNumber, setSelectedArticleNumber] = useState<string>(() => baseArticle.articleNumber);

  const [quantity, setQuantity] = useState<number>(initialQuantity ?? 1);

  const article = allArticles.find(a => a.articleNumber === selectedArticleNumber) ?? baseArticle;

  const price = getSplittedArticlePrice(article.price);

  const calculatedTotalPriceText = useMemo(() => {
    const currentQuantity = Number.isNaN(quantity) ? 0 : quantity;

    const priceValue = article.price;

    const total =
      currentQuantity *
      (article.sellAmount *
        (article.priceCode === PRICECODE_WEIGHTCONTROLLED ? article.approxWeight! : 1) *
        priceValue);

    return `CHF ${formatPrice(total, i18n.language)}`;
  }, [article.approxWeight, article.price, article.priceCode, article.sellAmount, i18n.language, quantity]);

  return {
    ...article,
    price,
    setSelectedArticleNumber,
    allArticles,
    calculatedTotalPriceText,
    quantity,
    setQuantity,
    isFutureAction: article.actionValidFrom ? isFuture(article.actionValidFrom) : undefined
  };
}
